export default {
  label: {
    xAxis: {
      title: 'Time',
    },
    yAxis: {
      title: 'Respondents',
    },
    bubble: {
      name: 'Name',
      value: 'Total Activity',
      hour: 'Time',
      opened: 'Open',
      answered: 'Answered',
      waiting: 'Waiting',
      closed: 'Closed',
      ignored: 'Ignored',
      percentage: 'Percentage per user',
      percentageGlobal: 'Global Percentage',
    },
  },
};
